import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

import { BulkDatabaseVersion, ZoneType } from 'src/app/core/api/models';
import { AppZoneSelectSearch } from 'src/app/core/types/app-zone-select-search.type';
import { ZonesService } from '../../../core/api/services/zones.service';
import { BaseSelectSearch } from './base/base-select-search.component';
import { BaseSelectSearchModule } from './base/base-select.search.module';

@Component({
    selector: 'zones-select-search',
    templateUrl: './base/base-select-search-template.html',
    imports: [BaseSelectSearchModule]
})
export class ZonesSelectSearchComponent
  extends BaseSelectSearch
  implements OnInit
{
  @Input('type') type: AppZoneSelectSearch = 'byParentId';
  @Input('bulkDatabaseVersion') bulkDatabaseVersion: BulkDatabaseVersion;
  @Input('zoneType') zoneType: ZoneType;

  constructor(protected currentService: ZonesService) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['zoneType'] || changes['id']) this.getItemsApi();
  }

  getItemsApi() {
    if ((!this.id || this.id == -1) && this.type === 'byParentId') {
      this.items = [];
      this.isFetchData = true;
      this.initLoading = false;
      return;
    }

    //country
    if (this.id === 'null') this.id = null;

    //country
    if (!this.zoneType) this.zoneType = 1;

    switch (this.type) {
      // byParentId
      case 'byParentId':
        this.currentService
          .zonesGetZonesByParentIdList({ ParentId: this.id })
          .pipe(this.basePipeOperators())
          .subscribe(this.baseObserver);
        break;
      // byZoneType
      case 'byZoneType':
        this.currentService
          .zonesGetZonesByTypeList({ Type: this.zoneType })
          .pipe(this.basePipeOperators())
          .subscribe(this.baseObserver);
        break;
      // forMap
      case 'forMap':
        this.currentService
          .zonesGetZonesByParentIdForMap({
            ParentId: this.id,
            BulkDatabaseVersion: this.bulkDatabaseVersion,
          })
          .pipe(this.basePipeOperators())
          .subscribe(this.baseObserver);
        break;
    }
  }
}
